import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const importerFormSchema = z.object({
  name: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.nameRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.nameRequired")),
  email: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.emailRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.emailRequired"))
    .email(i18nMessage("boCatalog:importerForm.emailInvalid")),
  phone: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.phoneRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.phoneRequired")),
  address: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.addressRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.addressRequired")),
  city: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.cityRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.cityRequired")),
  state: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.stateRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.stateRequired")),
  zip: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.zipRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.zipRequired")),
  country: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.countryRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.countryRequired")),
  ttbPermit: z
    .string({ required_error: i18nMessage("boCatalog:importerForm.ttbPermitRequired") })
    .min(1, i18nMessage("boCatalog:importerForm.ttbPermitRequired")),
  taxId: z.string().optional(),
  einNumber: z.string().optional(),
  duns: z.string().optional(),
  newFiles: z.array(z.string()).optional(),
  filesToDelete: z.array(z.string()).optional(),
});

export type ImporterFormData = z.infer<typeof importerFormSchema>;

export const IMPORTER_DEFAULT_VALUES: ImporterFormData = {
  name: "",
  email: "",
  phone: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  ttbPermit: "",
  taxId: "",
  einNumber: "",
  duns: "",
  newFiles: [],
  filesToDelete: [],
};
